'use client';

/**
 * @module
 * @category State
 */

import { useSyncExternalStore } from 'react';

export type ResolvedThemeMode = 'light' | 'dark';

const PREFERS_DARK = '(prefers-color-scheme: dark)';

const subscribe = (onChange: () => void) => {
  const query = window.matchMedia(PREFERS_DARK);
  query.addEventListener('change', onChange);
  return () => query.removeEventListener('change', onChange);
};

const readMode = (): ResolvedThemeMode => (window.matchMedia(PREFERS_DARK).matches ? 'dark' : 'light');

const readServerMode = (): ResolvedThemeMode | undefined => undefined;

export const useThemeMode = () => {
  const resolvedMode = useSyncExternalStore<ResolvedThemeMode | undefined>(subscribe, readMode, readServerMode);
  return { resolvedMode };
};
